import Article from "@mui/icons-material/Article";
import CampaignIcon from "@mui/icons-material/Campaign";
import Description from "@mui/icons-material/Description";
import Info from "@mui/icons-material/Info";
import MonetizationOn from "@mui/icons-material/MonetizationOn";

import { NavigationListItem } from "@/components/molecules/NavigationList/types";
import ROUTE_URLS from "@/constants/route-urls";
import { T2PayHomeMessages } from "@/messages/platforms/talk2PayHome/t2pay-home.messages";
import { TabItem } from "@/types/form.types";

import { T2PayTabs } from "./types";

export const T2PAY_TABS_ITEMS = (messages: T2PayHomeMessages): TabItem<T2PayTabs>[] => [
  { value: "generalInformationTab", label: messages.generalInformationTabLabel },
  { value: "documentsTab", label: messages.documentsTabTitle },
  { value: "ratesTab", label: messages.ratesTabTitle },
];

type NavigationProps = {
  messages: T2PayHomeMessages;
};

export type T2PayHomeNavigationIds =
  | "general-information"
  | "cadastral-situation"
  | "documents"
  | "rates"
  | "statement";

export const t2PayHomeNavigationItems = ({
  messages,
}: NavigationProps): NavigationListItem<T2PayHomeNavigationIds>[] => [
  {
    _id: "statement",
    title: messages.statementTabTitle,
    icon: <Article />,
    selectedIcon: <Article color="primary" />,
    href: ROUTE_URLS.statement,
  },
  {
    _id: "general-information",
    title: messages.generalInformationTabLabel,
    icon: <Info />,
    selectedIcon: <Info color="primary" />,
    href: ROUTE_URLS.generalInformation,
  },
  {
    _id: "cadastral-situation",
    title: messages.cadastralSituationTitle,
    icon: <CampaignIcon />,
    selectedIcon: <CampaignIcon color="primary" />,
    href: ROUTE_URLS.cadastralSituation,
  },
  {
    _id: "documents",
    title: messages.documentsTabTitle,
    icon: <Description />,
    selectedIcon: <Description color="primary" />,
    href: ROUTE_URLS.documents,
  },
  {
    _id: "rates",
    title: messages.ratesTabTitle,
    icon: <MonetizationOn />,
    selectedIcon: <MonetizationOn color="primary" />,
    href: ROUTE_URLS.rates,
  },
];

export const STATEMENT_TABLE_COLUMNS = (messages: T2PayHomeMessages) => {
  return [
    messages.dateColumn,
    messages.transactionColumn,
    messages.descriptionColumn,
    messages.valueColumn,
    messages.balanceColumn,
  ];
};
